import { RatgeberArticlePage, RatgeberArticlePageWithLocalImage } from "../../ratgeber/_types"
import { Suspense, useState } from "react"
import { useRouter } from "next/router"
import classNames from "classnames"
import styles from "./articleCard.module.scss"
import { CircularProgress, Divider } from "@mui/material"
import Image from "next/image"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"

const ArticleCard = ({ article, isFeatured = false }: { article: RatgeberArticlePageWithLocalImage; isFeatured?: boolean }) => {
  const [authorShown, setIsAuthorShown] = useState(false)
  const router = useRouter()

  const goToCategory = (e: React.MouseEvent) => {
    e.stopPropagation()
    router.push(`/ratgeber/${article.category_page.slug}`)
  }
  const goToArticle = () => router.push(`/ratgeber/${article.category_page.slug}/${article.meta.slug}`)

  if (isFeatured) {
    return (
      <div onClick={goToArticle} className={classNames(styles.featuredArticle, styles.ratgeberArticleCardOnIndexPage)}>
        <Suspense fallback={<CircularProgress />}>
          <div className={styles.ratgeberFeaturedArticleImageContainer}>
            <Image
              className={styles.ratgeberArticleImage}
              // style={{
              //   maxWidth: "100%",
              //   height: "auto",
              // }}
              // width={article.banner_image.width}
              // height={article.banner_image.height}
              src={article.banner_image.local_url}
              alt={article.banner_image.title}
              fill
              sizes="100vw"
              style={{
                objectFit: "cover",
              }}
            />
          </div>
        </Suspense>
        <div className={styles.articleMeta}>
          <StyledText
            style={{ cursor: "pointer" }}
            className={styles.categoryName}
            onClick={goToCategory}
            variant={"captions"}
            color={skColors.darkgreen[500]}
          >
            {article.category_page.title}
          </StyledText>
          {authorShown ? (
            <StyledText
              style={{ textAlign: "right" }}
              onClick={(e) => {
                e.stopPropagation()
                setIsAuthorShown((bool) => !bool)
              }}
              variant={"captions"}
              color={skColors.darkgreen[500]}
            >
              von: {article.authors.map((author) => author.name).join(", ")}
            </StyledText>
          ) : (
            <StyledText
              onClick={(e) => {
                e.stopPropagation()
                setIsAuthorShown((bool) => !bool)
              }}
              variant={"captions"}
              color={skColors.darkgreen[500]}
            >
              {new Date(article.meta.first_published_at).toLocaleDateString("de-DE", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </StyledText>
          )}
        </div>
        <div className={styles.featuredContent}><StyledText
          variant={"h3"}
          color={skColors.darkgreen[600]}
        >
          {article.title}
        </StyledText>
          <Divider className={styles.divider} />
          <StyledText
            className={styles.threeLineEllipse}
            variant={"pRegular"}
            color={skColors.darkgreen[600]}
          >
            {article.description}
          </StyledText></div>
      </div>
    )
  }

  return (
    <div onClick={goToArticle} className={styles.card}>
      <div className={styles.cardImage}>
        <Image
          className={styles.ratgeberArticleImage}
          src={article.banner_image.local_url}
          alt={article.banner_image.title}
          fill
          sizes="100vw"
          style={{
            objectFit: "cover",
          }}
        />
      </div>
      <div className={styles.cardMeta}>
          <StyledText
            style={{ cursor: "pointer" }}
            className={styles.categoryName}
            onClick={goToCategory}
            variant={"captions"}
            color={skColors.darkgreen[500]}
          >
            {article.category_page.title}
          </StyledText>
          {authorShown ? (
            <StyledText
              style={{ textAlign: "right" }}
              onClick={(e) => {
                e.stopPropagation()
                setIsAuthorShown((bool) => !bool)
              }}
              variant={"captions"}
              color={skColors.darkgreen[500]}
            >
              von: {article.authors.map((author) => author.name).join(", ")}
            </StyledText>
          ) : (
            <StyledText
              onClick={(e) => {
                e.stopPropagation()
                setIsAuthorShown((bool) => !bool)
              }}
              variant={"captions"}
              color={skColors.darkgreen[500]}
            >
              {new Date(article.meta.first_published_at).toLocaleDateString("de-DE", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })}
            </StyledText>
          )}
      </div>
      <div className={styles.cardTitle}>
        <StyledText variant={"h3"} color={skColors.darkgreen[600]}>
          {article.title}
        </StyledText>
      </div>
      <div className={styles.cardText}>
        <Divider className={styles.divider} />
        <StyledText className={styles.threeLineEllipse} variant={"pRegular"} color={skColors.darkgreen[600]}>
          {article.description}
        </StyledText>
      </div>
    </div>
  )
}

export default ArticleCard
